import * as tslib_1 from "tslib";
// Core components
import { AfterViewInit, EventEmitter, OnDestroy, OnInit } from '@angular/core';
// Third party components
import { FieldType } from '@ngx-formly/material';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators';
// Custom components
// @see https://stackblitz.com/edit/angular-g9txuh-zysdfi?file=src/app/autocomplete-type.component.ts
var AutocompleteTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AutocompleteTypeComponent, _super);
    function AutocompleteTypeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDestroy$ = new Subject();
        _this.search$ = new EventEmitter();
        _this.options$ = new Observable();
        _this.optionsLoading = false;
        _this.optionsInput$ = new Subject();
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    AutocompleteTypeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.value = this.formControl.value;
        if (!this.to.minTermLength) {
            this.to.minTermLength = 0;
        }
        this.options$ = this.buildOptions$();
    };
    /**
     * Build the options$ observable, pre-populated with the field's initial
     * values (if any) and then wired up to search on every optionsInput$ emission.
     *
     * @since 1.0.0
     */
    AutocompleteTypeComponent.prototype.buildOptions$ = function () {
        var _this = this;
        var initialValues = [];
        if (this.to.initialValues && this.to.initialValues.length) {
            initialValues = this.to.initialValues;
        }
        return concat(of(initialValues), this.optionsInput$.pipe(takeUntil(this.onDestroy$), // auto-unsubscribe on onDestroy()
        debounceTime(500), // max 1 query every 350 milliseconts
        tap(function () { return _this.optionsLoading = true; }), // Start loader
        distinctUntilChanged(), // Eliminate duplicate values
        switchMap(function (term) {
            // An empty/cleared term must yield no results rather than falling
            // through to the backend's default (unfiltered) listing
            if (!term || !term.trim()) {
                _this.optionsLoading = false;
                return of([]);
            }
            var options = {
                general: term,
            };
            if (typeof _this.to.getAll !== 'undefined') {
                options.getAll = _this.to.getAll;
            }
            if (!_this.to.search$) {
                _this.optionsLoading = false;
                if (options && Array.isArray(options) && options.length) {
                    return options;
                }
                return [];
            }
            var limit = typeof _this.to.limit !== 'undefined' ? _this.to.limit : 10;
            return _this.to.search$(0, limit, '', '', options)
                .pipe(map(function (res) {
                if (res.status) {
                    if (res.data.items) {
                        return res.data.items;
                    }
                    if (res.data) {
                        return res.data;
                    }
                }
                return [];
            }), catchError(function () { return of([]); }), // empty list on error
            tap(function () { return _this.optionsLoading = false; }));
        })));
    };
    /**
     * Handle afterViewInit of this component
     *
     * @since 1.0.0
     */
    AutocompleteTypeComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
     * Handle ngOnDestroy of this component
     *
     * @since 1.0.0
     */
    AutocompleteTypeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.onDestroy$.complete();
    };
    /**
     * Fired every time model data changes
     *
     * @param {*} data new model data
     */
    AutocompleteTypeComponent.prototype.onChange = function (data) {
        if (typeof this.to.callback === 'function') {
            this.to.callback(data);
        }
        // Some fields (@see to.resetOnSelect) want the dropdown's option list
        // cleared back to its initial state right after a selection, instead of
        // continuing to show the last search's stale results. Rebuilding the full
        // pipeline (rather than swapping in a plain of(initialValues)) keeps it
        // wired up to optionsInput$ so subsequent typing still triggers a search.
        if (this.to.resetOnSelect && data) {
            this.options$ = this.buildOptions$();
        }
    };
    return AutocompleteTypeComponent;
}(FieldType));
export { AutocompleteTypeComponent };
